module.exports = __webpack_public_path__ + "img/icon_SVG_Arrow_white.df6a3c05.svg";